<template>
  <div class="dialog" id="person-dialog" aria-hidden="true">
    <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
    <div
      role="dialog"
      class="dialog-content dialog-content--furniture"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-description"
    >
      <button
        data-a11y-dialog-hide
        class="dialog-close"
        aria-label="Close this dialog window"
      >
        <img
          src="@/assets/icons/dialog-close.svg"
          width="24"
          height="24"
          alt="Dialog close"
        />
      </button>

      <div class="project-add">
        <p class="project-add__heading">
          {{ $t("project_settings.team.add_person_to_project_title") }}
        </p>
        <form action="">
          <p v-if="!props.role" class="control__label">
            {{ $t("project_settings.team.user_type") }}:
          </p>
          <div v-if="!props.role" class="control control--radio">
            <input
              v-model="role"
              type="radio"
              name="type"
              value="architect"
              id="architect"
            />
            <label for="architect">
              {{ $t("project_settings.team.team_member") }}
            </label>
          </div>
          <div v-if="!props.role" class="control control--radio">
            <input
              v-model="role"
              type="radio"
              name="type"
              value="client"
              id="client"
            />
            <label for="client">
              {{ $t("project_settings.team.client") }}
            </label>
          </div>
          <!--                    Chwilowo nie ma być tego na dodawaniu członka do projektu-->
          <!--                    <div-->
          <!--                        class="control control&#45;&#45;input custom-select custom-select&#45;&#45;position"-->
          <!--                    >-->
          <!--                        <label for="position" class="control__label">{{$t('project_settings.team.position')}}</label>-->
          <!--                        <input-->
          <!--                            type="text"-->
          <!--                            id="position"-->
          <!--                            class="select"-->
          <!--                            :placeholder="$t('project_settings.team.select_position')"-->
          <!--                            readonly-->
          <!--                        />-->
          <!--                        <div class="custom-select__options">-->
          <!--                            <div class="custom-select__option" data-value="someone">-->
          <!--                                ktoś 1-->
          <!--                            </div>-->
          <!--                            <div class="custom-select__option" data-value="someonee">-->
          <!--                                ktoś 2-->
          <!--                            </div>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div class="control control--input">
            <label for="name" class="control__label">{{
              $t("project_settings.team.firstname")
            }}</label>
            <input
              v-model="firstName"
              type="text"
              id="name"
              :placeholder="$t('project_settings.team.enter_firstname')"
            />
          </div>
          <div class="control control--input">
            <label for="surname" class="control__label">{{
              $t("project_settings.team.lastname")
            }}</label>
            <input
              v-model="lastName"
              type="text"
              id="surname"
              :placeholder="$t('project_settings.team.enter_lastname')"
            />
          </div>
          <div class="control control--input">
            <label for="surname" class="control__label">{{
              $t("project_settings.team.phone_number")
            }}</label>
            <input
              v-model="phone"
              type="text"
              id="phone"
              :placeholder="$t('project_settings.team.enter_phone_number')"
            />
          </div>
          <div class="control control--input">
            <label for="email" class="control__label">{{
              $t("project_settings.team.email")
            }}</label>
            <input
              v-model="email"
              type="text"
              id="email"
              :placeholder="$t('project_settings.team.enter_email')"
            />
            <div v-show="errors.email" class="control__error">
              <div class="control__error-inner">
                {{ errors.email }}
              </div>
            </div>
          </div>
          <div
            class="project-add__button furniture__button"
            data-a11y-dialog-hide
          >
            <button @click="addNewMembersToProject">
              {{ $t("project_settings.team.add_button") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import { useI18n } from "vue-i18n";
import router from "@/router";
import AlertHelper from "@/helpsers/alert.helper";

export default {
  name: "AddMemberToProjectModal",
  props: {
    /** @type {CLIENT | ARCHITECT} */
    role: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n(),
      firstName = ref(""),
      lastName = ref(""),
      phone = ref(""),
      role = ref("client"),
      errorMessage = ref(""),
      alert = inject("alert"),
      deleteMemberModal = ref("");

    const personDialog = ref();

    const { handleSubmit, errors } = useForm({
      validationSchema: yup.object().shape({
        email: yup.string().email(t("register.validation.email")).trim(),
      }),
    });

    const { value: email } = useField("email");
    onMounted(() => {
      personDialog.value = new A11yDialog(
        document.querySelector("#person-dialog")
      );
    });
    function showModal() {
      personDialog.value.show();
    }

    const addNewMembersToProject = handleSubmit(() => {
      const data = {
        projectId: router.currentRoute.value.params.id,
        role: props.role ?? role.value.toUpperCase(),
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        phone: phone.value,
      };

      axios
        .post(ApiHelper.getInviteMembersToProjectUrl(), data, {
          headers: authHelper.authHeader(),
        })
        .then((result) => {
          personDialog.value.hide();
          emit("addMember", result.data);
          AlertHelper.show(
            alert,
            t("project_settings.team.save_success_title")
          );
        })
        .catch((error) => {
          errorMessage.value = ApiHelper.getResponseMessage(
            error.response?.data?.code
          );
          AlertHelper.show(alert, errorMessage.value, "", "error");
        });
    });

    return {
      addNewMembersToProject,
      firstName,
      lastName,
      phone,
      email,
      errors,
      role,
      errorMessage,
      deleteMemberModal,
      showModal,
      props,
    };
  },
};
</script>

<style scoped lang="scss">
.project-settings {
  &__team {
    &-inner {
      @media screen and (max-width: 1199px) {
        justify-content: center;
      }
    }
  }
}
.person-box {
  &__image {
    display: flex;
    object-fit: cover;
  }

  &__contact {
    a {
      display: block;
      min-height: 20px;
    }
  }
}

.project-add {
  &__button {
    button {
      &:hover {
        background: #e35748;
        cursor: pointer;
      }
    }
  }
}

.error-message {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  color: red;
  font-weight: 500;
}
</style>
